import { startCase } from 'lodash-es'
import { applyNutritionistMask } from 'utility/applyNutritionistMask'

export const getFilterPart = (filter: string, part: number) =>
  startCase(applyNutritionistMask(filter.split('.')[part]))
